import Client from './Client';
import ClientFragment from './ClientFragment';
import { joinDefined, titleCase } from '../../../util/strings';
import { validationHelper } from '../../../util/validation';
import { isNullOrUndefined } from '../../../util/objects';
import moment from 'moment';
import { isDefinedAndDifferent } from '../../../util/functions';

export default {
    label: 'Client',
    component: Client,
    fragment: ClientFragment,
    onLoad: data => {
        if (!!data.DateEnteredAustralia) {
            data.DateEnteredAustralia = data.DateEnteredAustralia.substring(0, 4);
        }
        if (!!data.ClientChangesFromPrePlan) {
            data.ClientChangesFromPrePlan = JSON.parse(data.ClientChangesFromPrePlan || '{}');
            if (!!data.ClientChangesFromPrePlan.DateEnteredAustralia) {
                data.ClientChangesFromPrePlan.DateEnteredAustralia = data.ClientChangesFromPrePlan.DateEnteredAustralia.substring(
                    0,
                    4
                );
            }
        }
    },
    formatSaveData: (saveData, state) => {
        if (!!state.UnknownDOB && !!saveData.DateOfBirth) {
            saveData.DateOfBirth = null;
        }

        if (saveData.Occupation) saveData.Occupation = titleCase(state.Occupation);
        if (saveData.FirstName) saveData.FirstName = titleCase(state.FirstName);
        if (saveData.MiddleName) saveData.MiddleName = titleCase(state.MiddleName);
        if (saveData.Surname) saveData.Surname = titleCase(state.Surname);

        if (state.PlaceOfBirthCountry === 'Australia') {
            saveData.DateEnteredAustralia = null;
        } else if (
            !state.PlaceOfBirth1 ||
            (state.PlaceOfBirth1.toLowerCase() === 'unknown' && !state.PlaceOfBirthCountry)
        ) {
            saveData.PlaceOfBirth1 = 'Unknown';
            saveData.PlaceOfBirthState = null;
            saveData.PlaceOfBirthCountry = null;
        }
        if (!isNullOrUndefined(saveData.DateEnteredAustralia)) {
            saveData.DateEnteredAustralia = `${saveData.DateEnteredAustralia}-01-01`;
        } else {
            delete saveData.DateEnteredAustralia;
        }
        if (saveData.Photos) {
            saveData.Photos = saveData.Photos.map(({ ID }) => ({ ID }));
        }
        if (saveData.MemorialPhoto) {
            saveData.MemorialPhotoID = saveData.MemorialPhoto.ID || '0';
            delete saveData.MemorialPhoto;
        }
    },
    validation: {
        onValidate: {
            FirstName: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'FirstName';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.required();
            },
            MiddleName: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'MiddleName';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                return validationHelper.ok();
            },
            Surname: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'Surname';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.required();
            },
            FamilyNameAtBirth: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'FamilyNameAtBirth';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                return validationHelper.ok();
            },
            Gender: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'Gender';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.required();
            },
            DateOfBirth: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'DateOfBirth';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional(
                        'Family entered: ' + moment(changes[fieldName]).format('YYYY-MM-DD')
                    );
                }
                if (getField('DateOfDeath1') < persistedValue)
                    return validationHelper.required('Must not be after date of death.');
                if (getField('UnknownDOB') === true || !isNullOrUndefined(persistedValue)) return validationHelper.ok();

                return validationHelper.required();
            },
            PlaceOfBirth1: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const city = 'PlaceOfBirth1';
                const state = 'PlaceOfBirthState';
                const country = 'PlaceOfBirthCountry';
                if (changes[city] !== undefined || changes[state] !== undefined || changes[country] !== undefined) {
                    return validationHelper.optional(
                        'Family entered: ' + joinDefined([changes[city], changes[state], changes[country]], ' ')
                    );
                }
                return validationHelper.ok();
            },
            PlaceOfBirthState: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'PlaceOfBirthState';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                return validationHelper.ok();
            },
            PlaceOfBirthCountry: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'PlaceOfBirthCountry';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                return validationHelper.ok();
            },
            DateEnteredAustralia: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'DateEnteredAustralia';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                const placeOfBirthCountry = getField('PlaceOfBirthCountry');
                const placeOfBirth1 = getField('PlaceOfBirth1');
                const dateEnteredUnknown = getField('DateEnteredAustraliaUnknown');

                if (placeOfBirthCountry === 'Australia' || placeOfBirth1 === 'Unknown' || dateEnteredUnknown) {
                    return validationHelper.ok();
                }

                if (!isNullOrUndefined(persistedValue)) {
                    const value = parseInt(persistedValue, 10);
                    const max = new Date().getFullYear();
                    const min = max - 120;
                    return value < min || value > max
                        ? validationHelper.required(`Must be between ${min} and ${max}`)
                        : validationHelper.ok();
                }

                return validationHelper.suggested();
            },
            Occupation: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'Occupation';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.suggested();
            },
            Pensioner: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'Pensioner';
                const typeFieldName = 'PensionType';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional(
                        'Family entered: ' +
                            (changes[fieldName] === 'Y' ? 'Yes' : 'No') +
                            (changes[typeFieldName] !== undefined ? ' (' + changes[typeFieldName] + ')' : '')
                    );
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.suggested();
            },
            PensionType: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const fieldName = 'PensionType';
                if (isDefinedAndDifferent(changes[fieldName], getField(fieldName))) {
                    return validationHelper.optional('Family entered: ' + (changes[fieldName] || '(empty)'));
                }
                if (hasValue) return validationHelper.ok();
                return validationHelper.suggested();
            },
            ResidentialAddress1: (newValue, persistedValue, hasValue, getField) => {
                const changes = getField('ClientChangesFromPrePlan') || {};
                const street = 'ResidentialAddress1';
                const city = 'ResidentialTown';
                const state = 'ResidentialState';
                const country = 'ResidentialCountry';
                const postcode = 'PostCode';
                if (
                    ![street, city, state, country, postcode].every(
                        fieldName => !isDefinedAndDifferent(changes[fieldName], getField(fieldName))
                    )
                ) {
                    return validationHelper.optional(
                        'Family entered: ' +
                            joinDefined(
                                [
                                    changes[street] || getField(street),
                                    changes[city] || getField(city),
                                    changes[state] || getField(state),
                                    changes[postcode] || getField(postcode),
                                    changes[country] || getField(country)
                                ],
                                ' '
                            )
                    );
                }
                return validationHelper.ok();
            }
        }
    }
};
